import { IContest, SubmissionCategory } from '../types/global/helper';
import { IContestInitialState } from '../redux/contest/types';

type CategoryHint = string | SubmissionCategory | undefined | null;

const isMongoId = (value: string) => /^[a-f\d]{24}$/i.test(value);

const categoryIdFromHint = (hint: CategoryHint, categories: SubmissionCategory[]): string | undefined => {
    if (!hint) return undefined;
    if (typeof hint === 'object') {
        return hint._id;
    }
    if (typeof hint === 'string') {
        if (isMongoId(hint)) return hint;
        const byName = categories.find(c => c.category_name === hint);
        return byName?._id;
    }
    return undefined;
};

/** Resolves the submission category Mongo id expected by the API. */
export function resolveSubmissionCategoryId(
    contestState: Pick<
        IContestInitialState,
        'selectedCategory' | 'selectedCategoryForSubmission' | 'selectedContestForSubmisison' | 'focusCampaign'
    >,
    hint?: CategoryHint,
): string | undefined {
    const contest: IContest | undefined =
        contestState.selectedContestForSubmisison ?? contestState.focusCampaign ?? undefined;
    const categories = contest?.categories ?? [];

    const fromHint = categoryIdFromHint(hint, categories);
    if (fromHint) return fromHint;

    const fromStored = categoryIdFromHint(contestState.selectedCategoryForSubmission as CategoryHint, categories);
    if (fromStored) return fromStored;

    return contestState.selectedCategory?._id;
}
